module.exports = __webpack_public_path__ + "media/contact/contactpage_img-5061382e.png";